import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { zip } from 'rxjs';
import { HeaderModule } from 'src/app/components/header/header.module';
import { ApiServiceService } from 'src/app/services/apiService/api-service.service';
import { MasterDataService } from 'src/app/services/masterData/master-data.service';

@Component({
  selector: 'app-view-emr-details',
  templateUrl: './view-emr-details.component.html',
  styleUrls: ['./view-emr-details.component.scss'],
  imports: [CommonModule, HeaderModule, IonicModule],
  standalone: true
})
export class ViewEmrDetailsComponent {

  constructor(private apiService: ApiServiceService, private masterDataService: MasterDataService, private activatedRoute: ActivatedRoute) { }

  emrData: any = {};
  currentDate = new Date();
  patientInfo: any = {};
  doctorObj: { [key: string]: string; } = {};
  departmentObj: { [key: string]: string; } = {};
  routeObj: { [key: string]: string; } = {};
  freqObj: { [key: string]: string; } = {};
  viewEmrDetails(visitId: string) {
    this.apiService.getData(`opd_service/emrs/getPatientEmr/${visitId}`).subscribe((emrRecords) => {
      if (emrRecords && Object.keys(emrRecords).length > 0) {
        this.emrData = emrRecords;
        this.getPAtientInfo(this.emrData.patientId);
        this.getDoctorDepartmentList();
      } else {
        alert('No EMR records found for this visit.');
      }
    });
  }

  getDoctorDepartmentList() {
    zip([this.masterDataService.getAllDoctorList(), this.masterDataService.getAllDepartmentList(), this.masterDataService.getRouteList(), this.masterDataService.getFrequencyList()]).subscribe(([dockerList, departList, routeList, freqList]) => {
      dockerList.forEach((obj: any) => this.doctorObj[obj.payableid] = obj.firstname + ' ' + obj.lastname);
      departList.forEach((obj: any) => this.departmentObj[obj.id] = obj.department_name);
      freqList.forEach((obj: any) => this.freqObj[obj.id] = obj.description);
      routeList.forEach((obj: any) => this.routeObj[obj.routeid] = obj.description);
    });
  }

  getPAtientInfo(patientId: string) {
    this.apiService.opdService(`registration/getPatientDemographicDetails?Id=${patientId}`).subscribe((res: any) => {
      this.patientInfo = res.result;
    });
  }

  ionViewWillEnter() {
    this.activatedRoute.paramMap.subscribe(params => {
      const visitId = params.get('visitId');
      if (visitId) {
        this.viewEmrDetails(visitId);
      }
    });
  }

  // ...existing code...
  downloadPdf() {
    // ensure apiService.printEMR returns an Observable<Blob>
    this.apiService.printEMR({
      patientId: this.emrData.patientId,
      OpdIpdId: this.emrData.OpdIpdId
    }).subscribe((blob: Blob) => {
      const fileBlob = new Blob([blob], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(fileBlob);
      const a = document.createElement('a');
      a.href = url;
      // optional: build a sensible filename
      const filename = `EMR_${this.emrData.OpdIpdId || this.emrData.patientId}_${new Date().toISOString().slice(0,19).replace(/[:T]/g,'-')}.pdf`;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    }, (err) => {
      console.error('PDF download error', err);
      alert('Failed to download PDF.');
    });
  }
// ...existing code...

  printEmr() {
    this.apiService.printEMR({
      "patientId": this.emrData.patientId,
      "OpdIpdId": this.emrData.OpdIpdId
    }).subscribe((response) => {
      const blob = new Blob([response], { type: 'application/pdf' });
      const fileUrl = window.URL.createObjectURL(blob);
      window.open(fileUrl, '_blank');
    })
  }
}
